import { Button } from "antd";
import { Col, Row, Table, Typography } from "antd/es";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getQueryParams, generateQuery } from "modules/utilities/utility";
// import ReactDatePicker from "react-datepicker";
import DownloadPendingInvoice from "./DownloadInvoiceCsv";
import InvoiceUploader from "./InvoiceUploadModal";
import { useFlaggedInvoiceData } from "./store";
const { Title } = Typography;
import CardDiv from "modules/common/card-div/CardDiv";

const FlaggedInvoices = () => {
  const history = useNavigate();
  const [orders, setOrders] = useState([]);
  const [caseId, setCaseId] = useState([]);
  const [orderId, setOrderId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sd, setSd] = useState("");
  const [ed, setEd] = useState("");
  const [page, setPage] = useState(parseInt(getQueryParams("page")) || 1);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { flaggedInvoiceData, fetchFlaggedInvoiceData } = useFlaggedInvoiceData();

  useEffect(() => {
    setOrders(flaggedInvoiceData);
  }, [flaggedInvoiceData]);

  useEffect(() => {
    const filterItems = [{ page }];
    history({ search: generateQuery(filterItems) });
  }, [history, page]);

  useEffect(() => {
    if (getQueryParams("sd")) setSd(moment(getQueryParams("sd")));
    if (getQueryParams("ed")) setEd(moment(getQueryParams("ed")));
  }, []);

  const handleInvoiceUpload = (record) => {
    setIsModalVisible(true);
    setCaseId(record.case_id);
    setOrderId(record.id);
  };

  const handleTableChange = (page, filter) => {
    setPage(page.current);
  };

  const columns = [
    {
      title: "Order Id",
      dataIndex: "order_display_id",
      key: "order_display_id",
      render: (value, record) => (
        <div>
          <Link className="link" to={`/lead-details/${record.case_id}`}>
            {value}
          </Link>
        </div>
      ),
    },
    {
      title: "Order Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render: (value) => moment(value).format("DD-MM-YYYY"),
    },
    {
      title: "Order Status",
      dataIndex: "status",
      key: "order_status",
    },
    {
      title: "Upload invoice",
      key: "uploadInvoice",
      width: "10%",
      render: (value, record) => {
        return (
          <Button onClick={() => handleInvoiceUpload(record)}>Upload</Button>
        );
      },
    },
  ];

  const _getFlaggedInvoice = useCallback(
    async (sd, ed) => {
      let _sd = null;
      let _ed = null;
      setLoading(true);
      if (!(!sd || sd === "" || ed === "" || !ed)) {
        _sd = moment(sd).format("YYYY-MM-DD");
        _ed = moment(ed).format("YYYY-MM-DD");
      }

	  //NOTE sd and ed is not used anywhere in the api code is for future updates

      const res = await fetchFlaggedInvoiceData(page, _sd, _ed);
      setLoading(false);
    },
    [page]
  );

  const handleDateFilter = async () => {
    await _getFlaggedInvoice(sd, ed);
  };

  const refreshUi = async () => {
    let _sd = null;
    let _ed = null;
    setLoading(true);
    if (!(!sd || sd === "" || ed === "" || !ed)) {
      _sd = moment(sd).format("YYYY-MM-DD");
      _ed = moment(ed).format("YYYY-MM-DD");
    }
    const res = await fetchFlaggedInvoiceData(1, _sd, _ed);
    if (res) setOrders(res);
    setLoading(false);
  };

  useEffect(() => {
    _getFlaggedInvoice(sd, ed);
  }, [_getFlaggedInvoice, ed, sd]);

  return (
    <div className="pt-4">
      <CardDiv
        title={
          <div className="d-flex justify-content-between align-items-center">
            <div style={{ display: "flex", alignItems: "center" }}>
              <h4 style={{ marginRight: "10px" }}>
                Orders Pending to be shipped
              </h4>
            </div>
            <div>
              <DownloadPendingInvoice
                data={orders?.data}
                type="pending-to-shipped"
              />
            </div>
          </div>
        }
        component={
          <div style={{ minHeight: "70vh", maxHeight: "75h", zIndex: "-1" }}>
            <InvoiceUploader
              caseId={caseId}
              orderId={orderId}
              isModalVisible={isModalVisible}
              setModalVisible={setIsModalVisible}
              refreshUi={refreshUi}
            />
            <div
              className="shadow table-row rounded-bottom scrollable-container"
              style={{
                fontSize: 13.2,
              }}
            >
              <div className="rounded-bottom">
                <Table
                  columns={columns}
                  onChange={(page, filter, sort) =>
                    handleTableChange(page, filter, sort)
                  }
                  loading={loading}
                  dataSource={orders?.data || []}
                  style={{ width: "100%", zIndex: "0" }}
                  pagination={{
                    current: page,
                    showSizeChanger: false,
                    pageSize: 10,
                    total: orders?.pagination?.rowCount || 1,
                  }}
                  scroll={{ y: 440 }}
                />
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default FlaggedInvoices;
